var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48.51 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#999;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Beats"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.25,45H9A8.86,8.86,0,0,1,.16,37.63,12.06,12.06,0,0,1,0,35.55c0-1.8,0-3.6,0-5.41a1.76,1.76,0,0,1,1.48-1.79,1.7,1.7,0,0,1,1.94,1.17,2.44,2.44,0,0,1,.1.81c0,1.82,0,3.64,0,5.46A5.37,5.37,0,0,0,9.2,41.46H39.31A5.37,5.37,0,0,0,45,35.79c0-1.84,0-3.68,0-5.52a1.75,1.75,0,0,1,1.78-1.94,1.77,1.77,0,0,1,1.75,1.92c0,2.28.08,4.57-.1,6.83A8.73,8.73,0,0,1,39.8,45c-5.18,0-10.36,0-15.55,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.49,27.8V2.18a4.18,4.18,0,0,1,0-.71A1.76,1.76,0,0,1,26,1.65c0,.2,0,.41,0,.61V28l.48-.45c2.14-2.13,4.26-4.27,6.4-6.39a1.75,1.75,0,0,1,3,.77,1.83,1.83,0,0,1-.59,1.79c-3,2.94-5.9,5.9-8.85,8.84l-.9.9a1.74,1.74,0,0,1-2.6,0q-5-5-9.94-9.94A1.77,1.77,0,1,1,15.53,21q3.22,3.21,6.43,6.43a3.27,3.27,0,0,1,.35.48Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.10d98f4df83e7769919a7e33ce362f54.svg";
export { ForwardRef as ReactComponent };